import { ROUTE_KEYS } from 'utils/constants';

export const LEKKI_COKITCHEN = 'Cokitchen Lekki';

export const metadataList = [
  {
    name: 'Meal keyword',
    route: ROUTE_KEYS.MEAL_METADATA
  },
  {
    name: 'Brand metadata',
    route: ROUTE_KEYS.BRAND_METADATA
  }
];
export const mealItemsList = [
  {
    name: 'Meal by category',
    route: ROUTE_KEYS.MEALS_BY_CATEGORY
  },
  {
    name: 'Meal by base ',
    route: ROUTE_KEYS.MEALS_BY_BASE
  }
];
export const baseItemsList = [
  {
    name: 'Base meal',
    route: ROUTE_KEYS.BASE_MEAL
  },
  {
    name: 'Base addon category',
    route: ROUTE_KEYS.BASE_ADDON_CATEGORY
  }
];
export const rewardsList = [
  {
    name: 'Levels',
    route: ROUTE_KEYS.LEVELS
  },
  {
    name: 'Streaks',
    route: ROUTE_KEYS.STREAKS
  },
  {
    name: 'Maintenance',
    route: ROUTE_KEYS.MAINTENANCE
  }
];

export const giftcardList = [
  {
    name: 'Categories',
    route: ROUTE_KEYS.GIFTCARD_CATEGORIES
  },
  /*{
    name: 'Amount options'
    route: ROUTE_KEYS.GIFTCARD_AMOUNT_OPTIONS
  },*/
  {
    name: 'Plain designs',
    route: ROUTE_KEYS.GIFTCARD_PLAIN_DESIGNS
  }
];
